"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCouponTrialDuration = exports.doesCouponAllowTrial = exports.isSubscriptionCouponMetadata = exports.isSubscriptionCoupon = void 0;
const isSubscriptionCoupon = (coupon) => typeof coupon.couponId === "string" &&
    typeof coupon.couponName === "string" &&
    typeof coupon.isValid === "boolean" &&
    typeof coupon.planId === "string" &&
    exports.isSubscriptionCouponMetadata(coupon.metadata);
exports.isSubscriptionCoupon = isSubscriptionCoupon;
const isSubscriptionCouponMetadata = (metadata) => (typeof metadata === "object" &&
    typeof metadata.title === "string" &&
    typeof metadata.version === "number") ||
    typeof metadata.text === "string";
exports.isSubscriptionCouponMetadata = isSubscriptionCouponMetadata;
const doesCouponAllowTrial = (coupon) => coupon.metadata ? !!coupon.metadata.allowsTrial : false;
exports.doesCouponAllowTrial = doesCouponAllowTrial;
const getCouponTrialDuration = (coupon) => { var _a, _b; return (_b = (_a = coupon.metadata) === null || _a === void 0 ? void 0 : _a.trialDays) !== null && _b !== void 0 ? _b : 14; };
exports.getCouponTrialDuration = getCouponTrialDuration;
//# sourceMappingURL=subscription_coupon_utils.js.map